<div class="content primary-bg auto-overflow width-match-parent" fxLayout>
  <img
    alt="Decoration"
    class="decoration position-top-right on-primary-low tint-white"
    src="../../../assets/images/RC_Logo_Icon.svg"
  />
  <mat-card class="mat-elevation-z7 b-rad-rounded">
    <router-outlet />
  </mat-card>
</div>
<recrewt-footer />
